import React from 'react';
import { useHistory } from 'react-router-dom';

import useTranslate from '../../../../../customHooks/useTranslate';
import Button from '../../../../../muiComponents/Button';
import { commonIcons } from '../../../../../utils/commonVariables/commonIcons';
import { zitoneoRoutes } from '../../../utils/zitoneoRoutes';
import { useZitoneoHotelPresentation } from '../../../contexts/ZitoneoContentContext';
import EmptyState from '../../../components/EmptyState';

const NoAddedServices = () => {
    const translate = useTranslate();
    const history = useHistory();
    const { hotel } = useZitoneoHotelPresentation();

    return (
        <EmptyState
            iconName='LockOutlined'
            title={translate('add_your_first_service')}
            description={translate('no_added_services_competitors')}
        >
            <Button
                variant='outlined'
                startIcon={commonIcons.EDIT}
                color='secondary'
                onClick={() =>
                    history.push(zitoneoRoutes.HOTEL_EDITOR_HOTEL(hotel.id))
                }
            >
                {translate('edit_services')}
            </Button>
        </EmptyState>
    );
};

export default NoAddedServices;
